"use strict";

exports.__esModule = true;
exports.getSimplifiedTag = void 0;

var _identifyTag = require("./identify-tag");

var _Identifiers = require("../../types/Identifiers");

var getSimplifiedTag = function getSimplifiedTag(seoTag) {
  var type = (0, _identifyTag.identifyTag)(seoTag);

  switch (type) {
    case _Identifiers.GENERAL_IDENTIFIERS.LINK:
      {
        var _seoTag$props = seoTag.props,
            rel = _seoTag$props.rel,
            href = _seoTag$props.href;
        return {
          label: rel,
          value: href,
          isDisabled: !!seoTag.disabled,
          generalIdentifier: _Identifiers.GENERAL_IDENTIFIERS.LINK
        };
      }

    case _Identifiers.GENERAL_IDENTIFIERS.OG_TAG:
      {
        return {
          label: seoTag.props.property,
          value: seoTag.props.content,
          isDisabled: !!seoTag.disabled,
          generalIdentifier: _Identifiers.GENERAL_IDENTIFIERS.OG_TAG
        };
      }

    case _Identifiers.GENERAL_IDENTIFIERS.STANDARD_META:
      {
        return {
          label: seoTag.props.name,
          value: seoTag.props.content,
          isDisabled: !!seoTag.disabled,
          generalIdentifier: _Identifiers.GENERAL_IDENTIFIERS.STANDARD_META
        };
      }

    default:
      {
        return null;
      }
  }
};

exports.getSimplifiedTag = getSimplifiedTag;